import React from 'react';
import { FormField } from 'taboola-ultimate-ui';
import { FormattedMessage } from '../../../taboola-common-frontend-modules/i18n';
import { useModal } from '../../../taboola-common-frontend-modules/modals';
import { PAYMENT_PROVIDER_NAME } from '../../config/PaymentProviderName';
import { KoreanKgInicisBankTransferDetailsModal } from './KoreanKgInicisBankTransferDetailsModal/KoreanKgInicisBankTransferDetailsModal';
import { StripeBankTransferDetailsModal } from './StripeBankTransferDetailsModal/StripeBankTransferDetailsModal';
import styles from '../BalanceAndPaymentsPanel/balanceAndPayments.module.scss';

export const useBankTransferDetailsModal = () => {
    const { open } = useModal();

    const openModal = async ({ vendor, amount, currency, bankTransfer }) => {
        if (PAYMENT_PROVIDER_NAME.STRIPE === vendor) {
            await open({
                title: (
                    <FormField
                        label={
                            <FormattedMessage
                                id="billingAndPayments.modal.bankTransferDetails.title"
                                defaultMessage="Bank Transfer Details"
                            />
                        }
                    />
                ),
                contentRenderer: () => <StripeBankTransferDetailsModal pageUrl={bankTransfer.url} />,
                className: styles['stripe-bank-transfer-details-modal'],
                hasCloseButton: true,
            });
        } else if (PAYMENT_PROVIDER_NAME.KG_INICIS === vendor) {
            await open({
                title: (
                    <FormattedMessage
                        id="billingAndPayments.modal.bankTransferDetails.kgInicis.title"
                        defaultMessage="Virtual Bank Account Information"
                        tagName="h2"
                    />
                ),
                contentRenderer: ({ onClose }) => (
                    <KoreanKgInicisBankTransferDetailsModal
                        onClose={onClose}
                        amount={amount}
                        currency={currency}
                        bankTransfer={bankTransfer}
                    />
                ),
            });
        }
    };

    return { openModal };
};
